import script from "./goRinSyo0082.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0082.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0082.vue?vue&type=style&index=0&id=235a7842&lang=scss"

const __exports__ = script;

export default __exports__